/**
 * The whole-page state shared by the not-found and the no-access screens: a glyph, the page's h1,
 * one sentence and one primary action back to the start.
 */

import type { ReactElement } from "react";
import { Link } from "react-router";

import type { IconName } from "../../shared/design-system/icons";
import { buttonClassName } from "../../shared/ui/atoms/Button";
import { Icon } from "../../shared/ui/atoms/Icon";
import styles from "./NotFoundPage.module.css";

export interface StatePageProps {
  readonly icon: IconName;
  readonly title: string;
  readonly body: string;
  readonly backLabel: string;
}

export function StatePage({ icon, title, body, backLabel }: StatePageProps): ReactElement {
  return (
    <section className={styles.state}>
      <span className={styles.icon}>
        <Icon name={icon} size="lg" />
      </span>
      <h1 className={styles.title} tabIndex={-1}>
        {title}
      </h1>
      <p className={styles.body}>{body}</p>
      <div className={styles.action}>
        <Link className={buttonClassName("primary")} to="/">
          {backLabel}
        </Link>
      </div>
    </section>
  );
}
